export enum InvoiceStatus {
Temp,
Cancelled,
Issued,
Payed,
}
